import { useHistory } from 'react-router';
import useLocale from '../useLocale';

function useCheckout() {
  const history = useHistory();
  const { routes: routesLocale } = useLocale();

  const redirectToCheckout = ({
    pid,
    serviceId = null,
    billingCycle = 'monthly',
    couponAvailable = false,
    coupon = null,
    onSuccessRoute = null,
  }) => {
    const onSuccess = {
      route: onSuccessRoute,
      state: {
        redirectFrom: routesLocale.fastcheckout,
      },
    };

    const checkoutData = {
      coupon,
      couponAvailable,
      billingCycle,
      serviceId,
    };

    history.push(`${routesLocale.fastcheckout}/${pid}`, { onSuccess, checkoutData });
  };

  return {
    redirectToCheckout,
  };
}

export default useCheckout;
